export class Unavailability {
    title: string;
    description: string;
    activate: boolean;
    constructor() {}
}